import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SummaryBadge from '@/components/dashboard/SummaryBadge'
import EntityTanAccordion from '@/components/dashboard/EntityTanAccordion'
import { complianceAccordionBase } from '@/constants/dashboardConstant'

// ==================== CountryAccordion ====================
// A single country accordion with its nested entity/TAN and category levels.
const CountryAccordion = ({ country, periodRange, onComplianceUpdated }) => {
  return (
    <Accordion
      defaultExpanded
      disableGutters
      sx={{
        ...complianceAccordionBase,
        backgroundColor: 'var(--white-color)',
        border: '1px solid var(--border-subtel)',
        mb: 1,
        '&:last-child': { mb: 0 },
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon sx={{ color: 'var(--forbrand-secondary)' }} />
        }
        sx={{
          px: 2,
          minHeight: 52,
          '& .MuiAccordionSummary-content': {
            alignItems: 'center',
            justifyContent: 'space-between',
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            sx={{
              fontSize: 'var(--font-size-md)',
              fontWeight: 500,
              color: 'var(--forbrand-primary)',
            }}
          >
            {country.countryName}
          </Typography>
          <Typography
            sx={{
              fontSize: 'var(--font-size-sm)',
              color: 'var(--forbrand-secondary)',
            }}
          >
            {country.entityCount} Entity
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <SummaryBadge
            label="Total:"
            value={country.total}
            bgColor="var(--bg-info-subtle)"
          />
          <SummaryBadge
            label="Completed:"
            value={country.completed}
            bgColor="var(--bg-light-green)"
          />
          <SummaryBadge
            label="Pending:"
            value={country.pending}
            bgColor="var(--bg-yellow-light)"
          />
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 0 }}>
        <Box
          sx={{
            backgroundColor: 'var(--bg-layer-1)',
            border: '1px solid var(--border-subtel)',
            borderTop: 'none',
            p: 2,
          }}
        >
          {(country.entityTans || []).map((entityTan, entityIndex) => (
            <EntityTanAccordion
              key={entityTan.tanUuid}
              entityTan={entityTan}
              periodRange={periodRange}
              defaultExpanded={entityIndex === 0}
              onComplianceUpdated={onComplianceUpdated}
            />
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default CountryAccordion
